export default __webpack_public_path__ + "static/media/icon_arrow_up.f21fc605.svg";